import { render, staticRenderFns } from "./DialogIdeaAddProblem.vue?vue&type=template&id=1177e6e6&scoped=true"
import script from "./DialogIdeaAddProblem.vue?vue&type=script&lang=js"
export * from "./DialogIdeaAddProblem.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaAddProblem.vue?vue&type=style&index=0&id=1177e6e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177e6e6",
  null
  
)

export default component.exports